// src/routes.js
import React from 'react';
import Application from './containers/app'
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'

/** 
<Route path="*" component={NotFound} />
*/

const Routes = (props) => (
    <Router>
      <Switch>
        <Route path="/" component={Application}/>
      </Switch>
    </Router>
);

export default Routes;



// WEBPACK FOOTER //
// ./src/routes.js